import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { CallToAction } from './CallToAction.js';
import { FacebookLink } from '../common/FacebookLink.js';
import { Svg } from '../common/Svg.js';
import { handleCloseClick as innerHandleCloseClick } from '../common/shareBarUtils.js';
import { EmailLink } from '../common/EmailLink.js';
import { SmsLink } from '../common/SmsLink.js';
import { FacebookMessengerLink } from '../common/FacebookMessengerLink.js';
import { InstagramLink } from '../common/InstagramLink.js';
import { MobileShareTray } from '../common/MobileShareTray.js';
import { NextdoorLink } from '../common/NextdoorLink.js';
import {
    FacebookShareInterstitial,
    getFacebookVariantLink,
    delayFun, clipboardCopyFun,
} from '../common/facebook-share/FacebookShareInterstitial';

// WS-33712: Currently running an A/B test of an interstitial to see if it helps fundraising.

const Headline = createReactClass({
    propTypes: {
        hasAutoDonationMatch: PropTypes.bool.isRequired,
        matchMultiplier: PropTypes.number,
    },

    matchText() {
        let matchWord;
        if (this.props.matchMultiplier === 2) {
            matchWord = 'doubled';
        } else if (this.props.matchMultiplier === 3) {
            matchWord = 'tripled';
        } else {
            matchWord = 'matched';
        }

        return `Donations to your project are currently being ${matchWord}. Share it with your friends and family!`;
    },

    render() {
        let headlineText;
        if (!this.props.hasAutoDonationMatch) {
            headlineText = 'Build momentum for your project. Share it with your friends and family!';
        } else {
            headlineText = this.matchText();
        }

        return (
            <h2 className="teacher-share-headline">
                {headlineText}
            </h2>
        );
    },
});

export const ProjectPageShareBar = createReactClass({
    propTypes: {
        // from JSP
        teacherSharebar: PropTypes.shape({
            projectUrl: PropTypes.string.isRequired,
            shouldShow: PropTypes.bool.isRequired,
            hasTff: PropTypes.bool.isRequired,
            hasAutoDonationMatch: PropTypes.bool.isRequired,
            matchMultiplier: PropTypes.number,
            projectTitle: PropTypes.string.isRequired,
            nextdoorInfo: PropTypes.shape({
                essay: PropTypes.string,
                teacherName: PropTypes.string,
                schoolName: PropTypes.string,
            }),
            instagramShareData: PropTypes.shape({
                classroomPhotoUrl: PropTypes.string,
                profilePhotoUrl: PropTypes.string,
                teacherName: PropTypes.string,
                costToComplete: PropTypes.number,
                totalPrice: PropTypes.number,
                fulfillmentTrailer: PropTypes.string,
                forceShow: PropTypes.boolean,
            }),

            tff: PropTypes.shape({
                expirationDate: PropTypes.string,
                name: PropTypes.string,
                amount: PropTypes.string,
            }),
        }),

        // defined globally
        projectId: PropTypes.number.isRequired,
        baseURL: PropTypes.string.isRequired,
        pageName: PropTypes.string.isRequired,

        getTafURL: PropTypes.func.isRequired,
        getTafEmail: PropTypes.func.isRequired,

        getTrackingLink: PropTypes.func.isRequired,
        facebookAppId: PropTypes.string.isRequired,

        getTwitterText: PropTypes.func.isRequired,
        root: PropTypes.any.isRequired, // the parent DOM node in which the bar is rendered
    },

    getInitialState: function () {
        return {
            showInterstitial: false,
            facebookLink: null,
        };
    },

    handleCloseClick: function (e) {
        innerHandleCloseClick(e, this.props.root);
    },

    render: function () {
        return (
            <div className="container">
                <a href="" aria-label="close" className="mobile delete" onClick={this.handleCloseClick}>
                    <Svg icon="delete" attributes={{ role: 'presentation' }} additionalClasses="is-button"/>
                </a>
                {/* <h2 className="teacher-share-headline">Build momentum for your project. Share it with your friends and family!</h2> */}
                <Headline
                    hasAutoDonationMatch={this.props.teacherSharebar.hasAutoDonationMatch}
                    matchMultiplier={this.props.teacherSharebar.matchMultiplier}
                />
                <CallToAction
                    className="teacher-share-cta"
                    hasTff={this.props.teacherSharebar.hasTff}
                    tffExpirationDate={this.props.teacherSharebar.tff.expirationDate}
                    tffName={this.props.teacherSharebar.tff.name}
                    tffAmount={this.props.teacherSharebar.tff.amount}
                />
                <ul className="teacher-share-buttons share-wrapper">

                    <li role="button">
                        <FacebookLink
                            className="button-secondary button-facebook heap-facebook-share js-variant-hack"
                            urlToShare={this.props.baseURL + this.props.teacherSharebar.projectUrl}
                            projectId={this.props.projectId}
                            pageName={this.props.pageName}
                            getTrackingLink={(url, campaign, pageName) => {
                                return getFacebookVariantLink(this.props.getTrackingLink, url, campaign, pageName);
                            }}
                            facebookAppId={this.props.facebookAppId}
                            fulfillmentTrailer={this.props.teacherSharebar.instagramShareData.fulfillmentTrailer}
                            projectSummary={this.props.teacherSharebar.nextdoorInfo.essay}
                            delayFun={delayFun}
                            clipboardCopyFun={clipboardCopyFun}

                            onFacebookClick={(event, facebookLink) => {
                                this.setState({ showInterstitial: true, facebookLink });
                            }}
                        >Post on Facebook</FacebookLink>
                    </li>
                    <li role="button">
                        <NextdoorLink
                            className="button-secondary button-nextdoor heap-nextdoor-share"
                            urlToShare={this.props.baseURL + this.props.teacherSharebar.projectUrl}
                            pageName={this.props.pageName}
                            getTrackingLink={this.props.getTrackingLink}
                            projectSummary={this.props.teacherSharebar.nextdoorInfo.essay}
                            teacherName={this.props.teacherSharebar.nextdoorInfo.teacherName}
                            schoolName={this.props.teacherSharebar.nextdoorInfo.schoolName}
                            onNextdoorClick={() => {}}
                        >Share on Nextdoor</NextdoorLink>
                    </li>
                    <li role="button" className="mobile">
                        <InstagramLink
                            urlToShare={this.props.baseURL + this.props.teacherSharebar.projectUrl}
                            className="button-secondary button-instagram heap-instagram-share"

                            getTrackingLink={this.props.getTrackingLink}
                            forceShow={this.props.teacherSharebar.instagramShareData.forceShow}
                            projectId={this.props.projectId}
                            classroomPhotoUrl={this.props.teacherSharebar.instagramShareData.classroomPhotoUrl}
                            profilePhotoUrl={this.props.teacherSharebar.instagramShareData.profilePhotoUrl}
                            teacherName={this.props.teacherSharebar.instagramShareData.teacherName}
                            costToComplete={this.props.teacherSharebar.instagramShareData.costToComplete}
                            totalPrice={this.props.teacherSharebar.instagramShareData.totalPrice}
                            fulfillmentTrailer={this.props.teacherSharebar.instagramShareData.fulfillmentTrailer}
                        >
                            Share on Instagram
                        </InstagramLink>
                    </li>
                    <li role="button">
                        <EmailLink
                            className="button-secondary button-email heap-email-share"
                            secure={false}
                            tafURL={this.props.getTafURL(this.props.projectId)}
                            pageName={this.props.pageName}
                            projectId={this.props.projectId}
                            getTafEmail={this.props.getTafEmail}
                            onEmailClick={() => {}}
                        >Share via email</EmailLink>
                    </li>
                    <li role="button">
                        <FacebookMessengerLink
                            className="button-secondary button-facebook heap-messenger-share"
                            projectId={this.props.projectId}
                            urlToShare={this.props.baseURL + this.props.teacherSharebar.projectUrl}
                            getTrackingLink={this.props.getTrackingLink}
                            pageName={this.props.pageName}
                            facebookAppId={this.props.facebookAppId}
                        >Share via Messenger</FacebookMessengerLink>
                    </li>

                    {/* Hidden when non-mobile */}
                    <li role="button">
                        <SmsLink
                            className="button-secondary button-sms heap-sms-share"
                            text={this.props.getTwitterText({ isUserTheTeacher: true, stripHandle: true })}
                            projectId={this.props.projectId}
                            urlToShare={this.props.baseURL + this.props.teacherSharebar.projectUrl}
                            onSmsClick={() => {}}
                        >Share via text</SmsLink>
                    </li>
                    <li role="button" className="mobile">
                        <MobileShareTray
                            className="button-secondary button-share-tray heap-sharetray-share"
                            useSpan={true}
                            projectId={this.props.projectId}
                            urlToShare={this.props.baseURL + this.props.teacherSharebar.projectUrl}
                            getTrackingLink={this.props.getTrackingLink}
                            onShareTrayClick={() => {}}
                            projectSummary={this.props.teacherSharebar.instagramShareData.fulfillmentTrailer}
                            pageName={this.props.pageName}
                            projectTitle={this.props.teacherSharebar.projectTitle}>Share link</MobileShareTray>
                    </li>

                </ul>
                <FacebookShareInterstitial show={this.state.showInterstitial}
                    hide={() => this.setState({ ...this.state, showInterstitial: false })} facebookLink={this.state.facebookLink} />
            </div>
        );
    },
});
